export function esRutaInternaValida(ruta) {
  if (typeof ruta !== "string") return false;
  const valor = ruta.trim();
  if (!valor.startsWith("/")) return false;
  if (/\s/.test(valor)) return false;
  if (/^\/\//.test(valor)) return false;
  return true;
}

export function marcarLeidaEnLista(lista, id) {
  return lista.map((item) => (item.id === id ? { ...item, read: true } : item));
}

export function eliminarDeLista(lista, id) {
  return lista.filter((item) => item.id !== id);
}

export function formatearFechaRelativa(fecha) {
  const ahora = new Date();
  const objetivo = new Date(fecha);
  const segundos = Math.floor((ahora - objetivo) / 1000);

  if (segundos < 60) return "hace un momento";
  const minutos = Math.floor(segundos / 60);
  if (minutos < 60) return `hace ${minutos} min`;
  const horas = Math.floor(minutos / 60);
  if (horas < 24) return `hace ${horas} h`;
  const dias = Math.floor(horas / 24);
  if (dias < 7) return `hace ${dias} d`;
  return objetivo.toLocaleDateString("es-CO");
}
